// @ts-check
import { apiRequest } from '../../../shared/api/base';

/**
 * Get family members accessible to the logged-in user (excluding self).
 * @returns {Promise<{ members: Array<{ authing_user_id: string, display_name: string | null, role: string }> }>}
 */
export function getFamilyMembers() {
  return apiRequest('/family/members');
}
